import { EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { MatSort } from '@angular/material';
import { of } from 'rxjs/observable/of';
import { isBefore, isDate } from 'date-fns';
import { DataTableSource } from '../../../classes/DataTableSource/datatablesource';
import { StudentCollegeInfo, } from '../../../services/application/application.service';
import { DialogService } from '../../../services/dialogs/dialogs.service';
import { SplashService } from '../../../services/splash/splash.service';
import { UserInfo } from '../../../services/user/user.service';
import { CourseRequestStatusPipe } from '../../../pipes/courserequeststatus.pipe';
import { EligibleCoursesPipe } from '../../../pipes/eligible-courses.pipe';
import { YesNoPipe } from '../../../pipes/yesno.pipe';
var CourseSelectionPanelComponent = /** @class */ (function () {
    function CourseSelectionPanelComponent(courseRequestStatusPipe, dialogService, eligCrsPipe, router, splashService, yesNoPipe) {
        this.courseRequestStatusPipe = courseRequestStatusPipe;
        this.dialogService = dialogService;
        this.eligCrsPipe = eligCrsPipe;
        this.router = router;
        this.splashService = splashService;
        this.yesNoPipe = yesNoPipe;
        // Outputs
        this.approveallcourses = new EventEmitter();
        this.approvecourse = new EventEmitter();
        this.eligilibity = new EventEmitter();
        this.fasttrack = new EventEmitter();
        this.refpdf = new EventEmitter();
        this.removecourse = new EventEmitter();
        this.returnform = new EventEmitter();
        this.selectcourse = new EventEmitter();
        this.setcourseref = new EventEmitter();
        this.setcoursealtref = new EventEmitter();
        this.undoremovecourse = new EventEmitter();
        // Private
        this.AllHeaders = [
            'Code',
            'CourseName',
            'Credits',
            'Required',
            'DateAdded',
            'DateRemoved',
            'DateApproved',
            'Status',
            'ReferenceNum',
            'AltReferenceNum',
            'Actions',
        ];
        this.AsAdvisor = false;
        this.AsCollegeAdmin = false;
        this.AsCollegeSupport = false;
        this.AsCounselor = false;
        this.AsDeveloper = false;
        this.AsDistrictAdmin = false;
        this.AsParent = false;
        this.AsSchoolAdmin = false;
        this.AsStudent = false;
        this.HasActiveRequests = false;
        this.HasRemovedRequests = false;
        this.HasUnscheduledRequests = false;
        this.ShowRemoved = false;
    }
    CourseSelectionPanelComponent.prototype.ngOnInit = function () { };
    CourseSelectionPanelComponent.prototype.ngOnDestroy = function () { };
    CourseSelectionPanelComponent.prototype.ngOnChanges = function () {
        var self = this;
        if (!self.CoursesData) {
            self.CoursesData = new DataTableSource([], null, self.sorter, self.SortCourses.bind(self));
        }
        self.FilteredCourses = null;
        // Parse out the courses
        var anyActive = false;
        var anyRemoved = false;
        var anyUnscheduled = false;
        var credits = 0;
        if (self.Courses && self.Courses.length) {
            self.NoData = false;
            // Parse through the provided list to determine if there are any entries which are not removed.
            self.Courses.forEach(function (item) {
                if (item.RemovedBy == null) {
                    anyActive = true;
                    credits += item.Credits;
                    if (!item.ReferenceNumber) {
                        anyUnscheduled = true;
                    }
                }
                else {
                    anyRemoved = true;
                }
            });
        }
        else {
            // Add an empty object to trigger the no data row
            self.NoData = true;
        }
        self.HasActiveRequests = anyActive;
        self.HasRemovedRequests = anyRemoved;
        self.HasUnscheduledRequests = anyUnscheduled;
        self.TotalCredits = credits;
        // Update the data source
        self.CoursesData.Update(self.Courses || [{}]);
        if (self.User) {
            self.AsAdvisor = self.User.IsAdvisor;
            self.AsCollegeAdmin = self.User.IsCollegeAdmin;
            self.AsCollegeSupport = self.User.IsCollegeSupport;
            self.AsCounselor = self.User.IsCounselor;
            self.AsDeveloper = self.User.IsDeveloper;
            self.AsDistrictAdmin = self.User.IsDistrictAdmin;
            self.AsParent = self.User.IsParent;
            self.AsSchoolAdmin = self.User.IsSchoolAdmin;
            self.AsStudent = self.User.IsStudent;
        }
        self.EligibilityByCourseGrade = self.SelectedCollege && self.SelectedCollege.EligibilityByCourseGrade != null;
        self.OrigEligCourseGrade = self.EligibilityByCourseGrade;
        self.OrigEligCourses = self.SelectedCollege && self.SelectedCollege.EligibilityByCourseGrade;
        self.SetupEligibilityCourses(self.SelectedCollege && self.SelectedCollege.EligibilityByCourseGrade);
        self.FastTrackAdvised = self.SelectedCollege && self.SelectedCollege.FastTrackAdvised;
        self.UpdateFiltering();
    };
    // #region Approval All Courses Method
    CourseSelectionPanelComponent.prototype.ApproveAllCourses = function (AsBypassAdmin) {
        this.approveallcourses.emit({ ActionNeeded: true, BypassAdmin: AsBypassAdmin });
    };
    // #endregion
    // #region Approve Course Choice Method
    CourseSelectionPanelComponent.prototype.ApproveCourseChoice = function (course) {
        if (!course) {
            return;
        }
        this.approvecourse.emit(course);
    };
    // #endregion
    // #region Checkbox Handler
    CourseSelectionPanelComponent.prototype.CheckboxHandler = function (event) {
        var _this = this;
        if (!event)
            return;
        if (!event.checked) {
            // Is there anything set as courses? If so, we must get a confirmation before wiping things out.
            (this.EligibilityByCourseGradeCourses && this.EligibilityByCourseGradeCourses.length
                ? this.dialogService.OpenConfirmationDialog({
                    TitleText: 'Confirmation Requested',
                    MessageText: "You are about to turn off the option for listing eligibility courses. The following courses are currently selected for this student/term:<br /><ul>" + this.EligibilityByCourseGradeCoursesList.reduce(function (p, c) { return p + ("<li>" + c + "</li>"); }, '') + "</ul><br />If you proceed, the system will remove all of these eligibility courses from the student for this term. Are you sure you wish to remove these courses?",
                    OKText: 'Yes - Remove All',
                    CancelText: 'No - Cancel',
                })
                : of(true)).subscribe(function (result) {
                if (!result) {
                    // User is canceling. Don't change the checkbox.
                    _this.EligibilityByCourseGrade = true;
                    return;
                }
                // The user opted to remove.
                _this.eligilibity.emit(null);
                _this.SetupEligibilityCourses(null);
            });
        }
        else {
            // Checkbox is on, so pop the dialog box to collect the courses.
            this.dialogService
                .OpenEligibleCoursesDialog({
                TitleText: 'Select Eligibility Courses',
                MessageText: 'Please select one or more courses from the list provided below which are being used to establish eligibility for the student:',
                Courses: this.EligibilityByCourseGradeCourses,
            })
                .subscribe(function (result) {
                if (!result) {
                    // The user canceled. We turn the checkbox back off in this case and do nothing.
                    _this.EligibilityByCourseGrade = false;
                    return;
                }
                // We have courses. Emit the choices that were selected to the parent as a single value.
                _this.eligilibity.emit(result);
            });
        }
    };
    // #endregion
    // #region Download Ref PDF
    CourseSelectionPanelComponent.prototype.DownloadRefPDF = function () {
        this.refpdf.emit();
    };
    // #endregion
    // #region Eligibility Change Handler Method
    CourseSelectionPanelComponent.prototype.EligibilityChangeHandler = function () {
        var _this = this;
        // Pop the dialog so changes can be made.
        this.dialogService
            .OpenEligibleCoursesDialog({
            TitleText: 'Select Eligibility Courses',
            MessageText: 'Please select one or more courses from the list provided below which are being used to establish eligibility for the student:',
            Courses: this.EligibilityByCourseGradeCourses,
        })
            .subscribe(function (result) {
            if (!result)
                return;
            // We have courses. Emit the choices that were selected to the parent as a single value.
            _this.eligilibity.emit(result);
        });
    };
    // #endregion
    // #region Fast Track Change Handler Method
    CourseSelectionPanelComponent.prototype.FastTrackChangeHandler = function (event) {
        if (!event) {
            return;
        }
        // Emit the new value
        this.fasttrack.emit(event.checked);
    };
    // #endregion
    // #region Remove Course Choice Method
    CourseSelectionPanelComponent.prototype.RemoveCourseChoice = function (course) {
        if (!course) {
            return;
        }
        this.removecourse.emit(course);
    };
    // #endregion
    // #region Return Form Method
    CourseSelectionPanelComponent.prototype.ReturnForm = function () {
        this.returnform.emit(true);
    };
    // #endregion
    // #region Select Course Method
    CourseSelectionPanelComponent.prototype.SelectCourse = function () {
        var self = this;
        // Pop up the dialog to make the selection, and wait for the return.
        self.dialogService
            .OpenCourseChoiceDialog({
            TitleText: 'Select course...',
            MessageText: "Use the selection boxes below to choose a course department and specific course to request. You may " +
                "also do a free-text search by using the provided space below, which will look for any courses which have " +
                "the provided text within their course name or course description. Once a course is selected, the " +
                "information for the course will be displayed for your review. To add the selected course to your list of " +
                "requested courses for this college, click the \"Select Course\" button. If you wish to exit without adding " +
                "a course, click the \"Cancel\" button." +
                (self.AsStudent
                    ? "<br /><br /><strong>Note: </strong> If the current term you are adding a course to has been " +
                        "previously approved by your school counselor or a college advisor, adding a new course <strong><u>" +
                        "<em>will</em></u></strong> require your counselor to re-approve the term's requests. This will also " +
                        "prevent your college advisor from seeing this term until approval has been re-granted."
                    : ''),
            Departments: self.SelectedCollegeDepartments,
            Courses: self.SelectedCollegeCourses,
            CanMakeAdoptionRequest: self.AsCounselor || self.AsSchoolAdmin,
        })
            .subscribe(function (coursechosen) {
            if (!coursechosen) {
                return;
            }
            // Is this an adoption request? If so, we need to ask and find out if they want to go to that form.
            if (coursechosen.RequestAdoption) {
                // Get a confirmation before proceeding.
                self.dialogService
                    .OpenConfirmationDialog({
                    TitleText: 'Confirmation Requested',
                    MessageText: "You are about to leave this page and go to the Course Adoption Request form. " +
                        "Are you sure you wish to go to that form?",
                    OKText: 'Yes',
                    CancelText: 'No',
                })
                    .subscribe(function (result) {
                    if (result === true) {
                        self.router.navigate(['/adoptionrequest', coursechosen.CourseChoice.DualEnrollCollegeCourseID]);
                    }
                });
            }
            else {
                // Emit what was chosen to go over to the parent.
                self.selectcourse.emit(coursechosen.CourseChoice);
            }
        });
    };
    // #endregion
    // #region Set Course Reference Number
    CourseSelectionPanelComponent.prototype.SetCourseReferenceNumber = function (course) {
        if (!course) {
            return;
        }
        this.setcourseref.emit(course);
    };
    // #endregion
    // #region Set Course Alt Reference Number
    CourseSelectionPanelComponent.prototype.SetCourseAltReferenceNumber = function (course) {
        if (!course) {
            return;
        }
        this.setcoursealtref.emit(course);
    };
    // #endregion
    // #region Setup Eligibility Courses
    CourseSelectionPanelComponent.prototype.SetupEligibilityCourses = function (coursesVal) {
        if (coursesVal == null) {
            this.EligibilityByCourseGradeCourses = [];
            this.EligibilityByCourseGradeCoursesList = [];
            return;
        }
        // Parse out the bitfield into distinct values, then convert to text as needed.
        var crs = [];
        var crslist = [];
        if (coursesVal & 1) {
            crs.push(1);
            crslist.push('AICE Math 1 AS');
        }
        if (coursesVal & 2) {
            crs.push(2);
            crslist.push('AICE MA&PR&ST 2 AL');
        }
        if (coursesVal & 4) {
            crs.push(4);
            crslist.push('Algebra 1 / Algebra 1 Honors');
        }
        if (coursesVal & 8) {
            crs.push(8);
            crslist.push('Algebra 2 / Algebra 2 Honors');
        }
        if (coursesVal & 16) {
            crs.push(16);
            crslist.push('Geometry / Geometry Honors');
        }
        if (coursesVal & 32) {
            crs.push(32);
            crslist.push('IB PRECALCULUS');
        }
        if (coursesVal & 64) {
            crs.push(64);
            crslist.push('Pre-AICE Math 2 IG');
        }
        if (coursesVal & 128) {
            crs.push(128);
            crslist.push('Pre-AICE Math 3 IG');
        }
        if (coursesVal & 256) {
            crs.push(256);
            crslist.push('PRECALCULUS Honors');
        }
        if (coursesVal & 512) {
            crs.push(512);
            crslist.push('English 4 / English 4 Honors');
        }
        if (coursesVal & 1024) {
            crs.push(1024);
            crslist.push('IB MYP Algebra 1');
        }
        this.EligibilityByCourseGradeCourses = crs;
        this.EligibilityByCourseGradeCoursesList = crslist;
    };
    // #endregion
    // #region Show Course Description Method
    CourseSelectionPanelComponent.prototype.ShowCourseDescription = function (course) {
        var self = this;
        // In order to show the info, we must find the correct college course info tied to this course choice.
        var chosenCourse = null;
        if (!self.SelectedCollegeCourses || !self.SelectedCollegeCourses.length) {
            self.splashService.SnackbarError('Unable to load course information for this college at this time.');
            return;
        }
        self.SelectedCollegeCourses.every(function (item) {
            if (course.CollegeCourseID === item.DualEnrollCollegeCourseID) {
                chosenCourse = item;
                return false; // Exit loop.
            }
            return true; // Loop.
        });
        if (!chosenCourse) {
            self.splashService.SnackbarError('Unable to load course information for this college at this time.');
            return;
        }
        // Pop up a dialog holding the course description information for the selected course.
        self.dialogService
            .OpenCourseDescriptionDialog({
            TitleText: 'Course Information',
            MessageText: '',
            Course: chosenCourse,
        })
            .subscribe(function (result) { });
    };
    // #endregion
    // #region Sort Courses Method
    CourseSelectionPanelComponent.prototype.SortCourses = function (First, Second) {
        var self = this;
        var PropA;
        var PropB;
        switch (self.sorter.active) {
            case 'Code':
                _a = [First.FullCode, Second.FullCode], PropA = _a[0], PropB = _a[1];
                break;
            case 'CourseName':
                _b = [First.Name, Second.Name], PropA = _b[0], PropB = _b[1];
                break;
            case 'Credits':
                _c = [First.Credits, Second.Credits], PropA = _c[0], PropB = _c[1];
                break;
            case 'Required':
                _d = [self.yesNoPipe.transform(First.PriorityRequest), self.yesNoPipe.transform(Second.PriorityRequest)], PropA = _d[0], PropB = _d[1];
                break;
            case 'DateAdded':
                _e = [First.DateCreated, Second.DateCreated], PropA = _e[0], PropB = _e[1];
                break;
            case 'DateRemoved':
                _f = [First.DateRemoved, Second.DateRemoved], PropA = _f[0], PropB = _f[1];
                break;
            case 'DateApproved':
                _g = [First.DateScheduled, Second.DateScheduled], PropA = _g[0], PropB = _g[1];
                break;
            case 'Status':
                _h = [
                    self.courseRequestStatusPipe.transform(First, self.SelectedCollege.FormStatus),
                    self.courseRequestStatusPipe.transform(Second, self.SelectedCollege.FormStatus),
                ], PropA = _h[0], PropB = _h[1];
                break;
            case 'ReferenceNum':
                _j = [First.ReferenceNumber, Second.ReferenceNumber], PropA = _j[0], PropB = _j[1];
                break;
        }
        if (isDate(PropA) || isDate(PropB)) {
            var baseSort = 0;
            if (isDate(PropA) && !isDate(PropB)) {
                baseSort = 1;
            }
            else if (isDate(PropB) && !isDate(PropA)) {
                baseSort = -1;
            }
            else if (isBefore(PropA, PropB)) {
                baseSort = -1;
            }
            else if (isBefore(PropB, PropA)) {
                baseSort = 1;
            }
            return baseSort * (self.sorter.direction === 'asc' ? 1 : -1);
        }
        else {
            var ValueA = PropA != null && PropA !== '' ? (isNaN(+PropA) ? PropA : +PropA) : PropA;
            var ValueB = PropB != null && PropB !== '' ? (isNaN(+PropB) ? PropB : +PropB) : PropB;
            return (ValueA < ValueB ? -1 : 1) * (self.sorter.direction === 'asc' ? 1 : -1);
        }
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    };
    // #endregion
    // #region Undo Remove Course Choice Method
    CourseSelectionPanelComponent.prototype.UndoRemoveCourseChoice = function (course) {
        if (!course) {
            return;
        }
        this.undoremovecourse.emit(course);
    };
    // #endregion
    // #region Update Filtering Method
    CourseSelectionPanelComponent.prototype.UpdateFiltering = function () {
        var _this = this;
        var self = this;
        var fcourses = (this.Courses || []).filter(function (item) {
            return _this.ShowRemoved || !item.RemovedBy;
        });
        self.NoData = !fcourses.length;
        self.FilteredCourses = fcourses;
        self.CoursesData.Update(self.FilteredCourses);
        // Set up headers for display
        self.VisibleHeaders = [];
        if (self.SmallDisplay) {
            self.VisibleHeaders.push('SmallDisplay');
        }
        else {
            self.VisibleHeaders.push('Code', 'CourseName', 'Credits', 'Required', 'DateAdded');
            if (self.ShowRemoved) {
                self.VisibleHeaders.push('DateRemoved');
            }
            else {
                self.VisibleHeaders.push('DateApproved');
            }
            self.VisibleHeaders.push('Status', 'ReferenceNum', 'AltReferenceNum');
            if (self.SelectedCollege &&
                (self.SelectedCollege.FormStatus !== 10 || self.AsDistrictAdmin) &&
                self.SelectedCollege.HistoricalRecord !== true) {
                self.VisibleHeaders.push('Actions');
            }
        }
        // Set which visible shown columns are available. Show the NoCourses entry if either there are no courses, or
        // the only courses are removed and we're not showing those.
        self.ShownColumns =
            self.NoData || (!self.HasActiveRequests && !self.ShowRemoved)
                ? ['NoCourses']
                : self.SmallDisplay
                    ? ['SmallDisplay']
                    : self.VisibleHeaders.slice();
    };
    return CourseSelectionPanelComponent;
}());
export { CourseSelectionPanelComponent };
// #region Custom Classes
// #region Approve Request Info Class
var ApproveRequestInfo = /** @class */ (function () {
    function ApproveRequestInfo() {
    }
    return ApproveRequestInfo;
}());
export { ApproveRequestInfo };
// #endregion
// #endregion



// WEBPACK FOOTER //
// ./src/app/ui/courseselectionpanel/courseselectionpanel.component.ts.pre-build-optimizer.js